import { Chip, useTheme } from "@mui/material";

const CustomChip = (props: any) => {
  const theme = useTheme();
  const { label, textColor, bgColor, size = "small", ...otherProps } = props;
  const muiSize = ["small", "medium"];

  let fontSize = undefined;
  let useSize: "small" | "medium" = "small";
  switch (size) {
    case "large":
      fontSize = theme.typography.subtitle2.fontSize;
      break;
    case "x-large":
      fontSize = theme.typography.subtitle1.fontSize;
      break;
    default:
      useSize = size;
      break;
  }

  return (
    <>
      {!muiSize.includes(size) ? (
        <Chip
          label={label}
          {...otherProps}
          sx={{
            backgroundColor: bgColor,

            "& .MuiChip-label": {
              color: textColor,
              fontSize: fontSize,
            },
          }}
        />
      ) : (
        <Chip
          label={label}
          size={useSize}
          {...otherProps}
          sx={{
            backgroundColor: bgColor,
            "& .MuiChip-label": {
              color: textColor,
            },
          }}
        />
      )}
    </>
  );
};

export default CustomChip;
